
import { Component, Vue, Prop } from "nuxt-property-decorator";
import { MainMenu } from "~/types/components";

@Component({})
export default class TheMenu extends Vue {
  @Prop() mainMenu!: MainMenu[];
}
